module.exports = __webpack_public_path__ + "static/startup-7-7fe9aa3dd56cb06e9cd2dc131a16c81d.svg";